<div class="modal-content">
  <div class="modal-body modal-padding">
    <h5>Confirm Delete</h5>
    <p>Are you sure you want to delete {{data.ids.length>1?'these':'this'}} bookmark{{data.ids.length>1?'s':''}}?</p>
    <div class="button-wrapper">
      <button (click)="delete()" class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721"
        viewindex="0">
        Yes
      </button>
      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
    </div>
  </div>
</div>